import { api as client } from './client';

/**
 * Send a chat message to the AI
 */
export const sendChatMessage = async (message, conversationHistory = []) => {
  const response = await client.post('/chat', {
    message,
    conversationHistory
  });
  return response.data;
};

/**
 * Get suggested questions
 */
export const getSuggestedQuestions = async () => {
  const response = await client.get('/chat/suggestions');
  return response.data;
};
